import React, { useEffect, useState } from 'react';
import search from "../../images/icons/search.png"
import events from "../../images/icons/events.png"
import update from "../../images/icons/update.png"
import { BsArrowUp, BsChevronDoubleRight, BsArrowDown } from "react-icons/bs";
import { Link } from "react-router-dom";
import axios from 'axios';
import { TailSpin } from 'react-loader-spinner';



const sortedList = (data, order) => {

    if (order === 'up') {
        return data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)).reverse()
    }
    if (order === 'down') {
        return data.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
    }
}



const WallBoxes = () => {
    const [masterChecked, setMasterChecked] = useState(false)
    const [selectedList, setSelectedList] = useState([])
    const [currentSort, seCurrentSort] = useState('up')
    const [wallBoxes, setWallBoxes] = useState([])
    const [pageCount, setPageCount] = useState([0])
    const [currentPage, setCurrentPage] = useState(1)
    const [isFetcing, setIsFetching] = useState(true)
    const [totalWallBoxCount, setTotalWallBoxCount] = useState()


    useEffect(() => {
        setIsFetching(true)
        /*  http://116.203.191.150:5013 */
        axios.get(`http://116.203.191.150:5013/api/wallbox_info?page=${currentPage}&page_size=20`, {
            headers: {
                authorization: "Bearer PuUf.9\\fMR~LkLE_=bF*_,r9niN&$Z"
            }
        })
            .then(response => {
                const walloxes = response.data.requested_wallboxes
                const totalWallbox = response.data.total_wallbox_count
                setTotalWallBoxCount(totalWallbox)
                setPageCount(Math.ceil(totalWallbox / 20))
                if (walloxes) {
                    setIsFetching(false)
                    walloxes.forEach(element => {
                        element.selected = false
                    });
                    setWallBoxes(walloxes)
                }
            })
            .catch(error => {
                console.log(error)
            })
    }, [currentPage])


    const onMasterCheck = (e) => {
        let tempList = wallBoxes;
        // Check/ UnCheck All Items
        tempList.map((user) => (user.selected = e.target.checked));

        //Update State
        setMasterChecked(e.target.checked)
        setWallBoxes(tempList)
        setSelectedList(wallBoxes.filter((e) => e.selected))
    }



    const onItemCheck = (e, item) => {
        let tempList = wallBoxes;
        tempList.map((user) => {
            if (user.id === item.id) {
                user.selected = e.target.checked;
            }
            return user;
        });

        //To Control Master Checkbox State
        const totalItems = wallBoxes.length;
        const totalCheckedItems = tempList.filter((e) => e.selected).length;

        // Update State
        setMasterChecked(totalItems === totalCheckedItems)
        setWallBoxes(tempList)
        setSelectedList(wallBoxes.filter((e) => e.selected))
    }

    const getSelectedRows = () => {
        setSelectedList(wallBoxes.filter((e) => e.selected))
    }

    const onSortChange = () => {
        let nextSort;
        if (currentSort === 'down') {
            nextSort = 'up'
        }
        else if (currentSort === 'up') {
            nextSort = 'down'
        }
        seCurrentSort(nextSort)
    };


    return (
        <div className="table-componet">
            <div className="row">
                <div className="col-md-12">
                    <div className="tab__content">
                        <table className="table box-table">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={masterChecked}
                                            id="mastercheck"
                                            onChange={(e) => onMasterCheck(e)}
                                        />
                                    </th>
                                    <th scope="col">ID</th>
                                    <th scope="col" className="serialT">Wallbox Serial</th>
                                    <th scope="col" className="FirmwareT">Firmware Version</th>
                                    <th onClick={onSortChange} scope="col" className="id">
                                        <span className="d-installed">Date installed {currentSort === "up" ? <BsArrowUp /> : <BsArrowDown />} </span>
                                    </th>
                                    <th scope="col" className="functionsT">Functions </th>
                                    <th scope="col" className="ownerT">Owner</th>
                                    <th scope="col" className="statusT">Status</th>
                                    <th scope="col" className="actionsT">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    wallBoxes.length && !isFetcing ? sortedList(wallBoxes, currentSort).map((wallbox, index) => (
                                        <SingleRow onItemCheck={onItemCheck} key={index} wallBox={wallbox} />
                                    ))
                                        :
                                        <div className="router-loading-spinner">
                                            <TailSpin width={50} height={50} color="#002060" />
                                        </div>
                                }

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div className="pagination-content">
                <ul>
                    {
                        [...Array(pageCount).keys()].map(avc => <li className={currentPage === avc + 1 && "active"} onClick={() => setCurrentPage(avc + 1)}>{avc + 1}</li>)
                    }
                    {
                        currentPage !== pageCount && <li onClick={() => setCurrentPage(currentPage < pageCount ? currentPage + 1 : currentPage)}><BsChevronDoubleRight /></li>
                    }

                </ul>
                <div className="pageRight">
                    <span>Showing 20 of {totalWallBoxCount} items</span>
                </div>
            </div>
        </div>
    );
};


const SingleRow = ({ onItemCheck, wallBox }) => {

    const { id, serial_number, firmware_version, created_at, owner, status, functions_list } = wallBox

    const date = new Date(created_at).toLocaleDateString()
    const dateSplit = date.split("/")
    const month = dateSplit[0].length === 1 ? "0" + dateSplit[0] : dateSplit[0]
    const day = dateSplit[1].length === 1 ? "0" + dateSplit[1] : dateSplit[1]
    const finalDate = dateSplit[2] + " - " + month + " - " + day

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }


    let functionList = functions_list ? functions_list.split(",") : []


    return (
        <tr className={wallBox.selected ? "selected" : ""}>
            <th scope="row">
                <input
                    type="checkbox"
                    checked={wallBox.selected}
                    className="form-check-input"
                    id="rowcheck{user.id}"
                    onChange={(e) => onItemCheck(e, wallBox)}
                />
            </th>
            <td><span>{id}</span></td>
            <td className="wallboxSerial"><span><Link to={`/wallbox/${serial_number}`}>{serial_number}</Link></span></td>
            <td className="FirmwareVersion"><span>v {firmware_version}</span></td>
            <td className="Dateinstalled"><span>{finalDate}</span></td>
            <td className="Functions">
                <span>
                    {
                        functionList.map((func, index) => <button key={index} className={func}>{func}</button>)
                    }

                </span>
            </td>
            <td className="Owner"><span>{owner || "Unknown User"}</span></td>
            <td className="Stat"><span className={status}>{capitalizeFirstLetter(status)}</span></td>
            <td className="Actions">
                <span>
                    <button><img src={events} alt="" /> Events</button>
                    <button><img src={update} alt="" /> Update</button>
                    <button><img src={search} alt="" /></button>
                </span>
            </td>
        </tr>
    )
}


export default WallBoxes;